import { FC } from "react";
import { useHistory } from "react-router";

import { Alert, Button, Text } from "@livechat/design-system-react-components";

import { AgentsRoutes } from "routes/agents/constants";

import { trackContactAdminsClicked } from "./analytics";
import { EmailSettingsSubsection } from "./routes";

interface IProps {
  section: EmailSettingsSubsection;
}

export const NotAllowedBanner: FC<IProps> = ({ section }) => {
  const history = useHistory();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleButtonClick = () => {
    history.push(AgentsRoutes.Agents);
    trackContactAdminsClicked(section);
  };

  return (
    <Alert kind="info" css={{ maxWidth: "800px" }}>
      <Text>
        You are not allowed to manage email addresses.{" "}
        <Button kind="link-light" onClick={handleButtonClick}>
          Contact one of your Admins
        </Button>{" "}
        to do so.
      </Text>
    </Alert>
  );
};
